import React from "react";

function GiftModalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79"
      height="67"
      fill="none"
      viewBox="0 0 79 67"
    >
      <g strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="#FFBE1E"
          strokeWidth="2"
          d="M69 1l-1.9 5.8a2 2 0 01-1.287 1.288L60 10l5.8 1.9a2.001 2.001 0 011.288 1.287L69 19l1.9-5.8a2.001 2.001 0 011.287-1.288L78 10l-5.8-1.9a2 2 0 01-1.288-1.287L69 1z"
        ></path>
        <g stroke="#FFBE1E" strokeWidth="2">
          <path d="M53 17l-1.912 5.813a2 2 0 01-1.275 1.275L44 26l5.813 1.912a2 2 0 011.275 1.275L53 35l1.912-5.813a2 2 0 011.275-1.275L62 26l-5.813-1.912a2 2 0 01-1.275-1.275L53 17z"></path>
          <path d="M46 17v4"></path>
          <path d="M60 31v4"></path>
          <path d="M44 19h4"></path>
          <path d="M58 33h4"></path>
        </g>
        <path
          stroke="#1E1D1E"
          strokeWidth="2.5"
          d="M46.333 44v20.833H13V44"
        ></path>
        <path stroke="#1E1D1E" strokeWidth="2.5" d="M30 64V44"></path>
        <path
          stroke="#1E1D1E"
          strokeWidth="2.5"
          d="M33.191 7L4 36.732l7.433 7.298 29.191-29.732L33.191 7z"
        ></path>
        <path
          stroke="#1E1D1E"
          strokeWidth="2.5"
          d="M46.129 43.224l-32.13.278.004.42 32.13-.277-.004-.421z"
        ></path>
        <path
          stroke="#1E1D1E"
          strokeWidth="2.5"
          d="M17.768 21.567l-6.851 6.4a5.208 5.208 0 11-7.11-7.613c5.328-4.977 13.96 1.213 13.96 1.213z"
        ></path>
        <path
          stroke="#1E1D1E"
          strokeWidth="2.5"
          d="M17.768 21.567l6.851-6.4a5.209 5.209 0 00-7.11-7.612c-5.329 4.978.259 14.012.259 14.012z"
        ></path>
      </g>
    </svg>
  );
}

export default GiftModalIcon;
